// PT3 — boss phase-2 moveset selection. Pure + deterministic: picks which attack a boss uses this beat.
// Below its enrage threshold a boss interleaves a NOVA desperation attack into its normal rotation, so the
// fight visibly escalates into a second phase instead of merely speeding up. No rng — driven by patternIdx.

/** The attack to run for this beat. Enraged bosses fire NOVA on every 3rd beat; otherwise cycle the list. */
export function bossPattern(patterns: readonly string[], idx: number, enraged: boolean): string {
  if (enraged && idx % 3 === 2) return 'nova'
  const list = patterns.length > 0 ? patterns : ['slam']
  return list[idx % list.length]
}
